function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  transform: "translate(958 878)",
  fill: "#0a9ba9",
  stroke: "#00788f",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_21",
  "data-name": "Path 21",
  d: "M80.7.032a1.314,1.314,0,0,1,1.377-1.313A1.324,1.324,0,0,1,83.456.032a1.324,1.324,0,0,1-1.377,1.312A1.314,1.314,0,0,1,80.7.032Zm.54,2.369h1.642a.3.3,0,0,1,.3.3V9.968a.3.3,0,0,1-.3.3H81.242a.3.3,0,0,1-.3-.3V2.7A.3.3,0,0,1,81.242,2.4Z",
  fill: "#fff"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(-958 -878)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "i",
    transform: "translate(885.921 883.507)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    style: {
      isolation: "isolate"
    }
  }, _ref3))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b28bc28a.svg";
export { ForwardRef as ReactComponent };